import { Component, Input } from '@angular/core';

@Component({
  selector: 'iconify',
  imports: [],
  templateUrl: './iconify.component.html',
  styleUrl: './iconify.component.scss',
  host: {
    ngSkipHydration: 'true'
  }
})
export class IconifyComponent {

  @Input() name = '';
  @Input() classNames = '';
  @Input() size:number | string = 0;

  get style(){
    return `
      ${this.size ? `font-size: ${this.size}px;` : ''}
    `
  }
}
